import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class GetRateSample extends Component {
    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken } = this.props;

        return (
            <pre className="sampleCode">
{`namespace Moneris
{ 
 using System;

 using System.Text;
 using System.Collections;

 public class TestCanadaMCPGetRate
 { 
  public static void Main(string[] args)
  { 
   string store_id = "`}{this.getValue(storeId, "storeId")}{`";
   string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
   string processing_country_code = "CA";
   bool status_check = false;

   MCPGetRate mcpGetRate = new MCPGetRate();

   mcpGetRate.SetMCPVersion("1.0"); //MCP Version number. Should always be 1.0
   mcpGetRate.SetMCPRateTxnType("P"); //P or R are valid values (Purchase or Refund)

   MCPRate rate = new MCPRate();

   rate.AddCardholderAmount("500", "840");
   rate.AddMerchantSettlementAmount("500", "840");
   mcpGetRate.SetMCPRateInfo(rate);

   HttpsPostRequest mpgReq = new HttpsPostRequest();

   mpgReq.SetProcCountryCode(processing_country_code);
   mpgReq.SetTestMode(true); //false or comment out this line for production transactions
   mpgReq.SetStoreId(store_id);
   mpgReq.SetApiToken(api_token);
   mpgReq.SetTransaction(mcpGetRate);
   mpgReq.Send();

   try
   {
    Receipt receipt = mpgReq.GetReceipt();

    Console.WriteLine("RateTxnType = " + receipt.GetRateTxnType());
    Console.WriteLine("MCPRateToken = " + receipt.GetMCPRateToken());
    Console.WriteLine("RateInqStartTime = " + receipt.GetRateInqStartTime()); //The time (unix UTC) of when the rate is requested
    Console.WriteLine("RateInqEndTime = " + receipt.GetRateInqEndTime()); //The time (unix UTC) of when the rate is returned
    Console.WriteLine("RateValidityStartTime = " + receipt.GetRateValidityStartTime()); //The time (unix UTC) of when the rate is valid from
    Console.WriteLine("RateValidityEndTime = " + receipt.GetRateValidityEndTime()); //The time (unix UTC) of when the rate is valid until
    Console.WriteLine("RateValidityPeriod = " + receipt.GetRateValidityPeriod()); //The time in minutes this rate is valid for
    Console.WriteLine("ResponseCode = " + receipt.GetResponseCode());
    Console.WriteLine("Message = " + receipt.GetMessage());
    Console.WriteLine("Complete = " + receipt.GetComplete());
    Console.WriteLine("TransDate = " + receipt.GetTransDate());
    Console.WriteLine("TransTime = " + receipt.GetTransTime());
    Console.WriteLine("TimedOut = " + receipt.GetTimedOut());
    //RateData

    for (int index = 0; index < receipt.GetRatesCount(); index++)
    { 
     Console.WriteLine("MCPRate = " + receipt.GetMCPRate(index));
     Console.WriteLine("MerchantSettlementCurrency = " + receipt.GetMerchantSettlementCurrency(index));
     Console.WriteLine("MerchantSettlementAmount = " + receipt.GetMerchantSettlementAmount(index));
     //Domestic(CAD) amount
     Console.WriteLine("CardholderCurrencyCode = " + receipt.GetCardholderCurrencyCode(index));
     Console.WriteLine("CardholderAmount = " + receipt.GetCardholderAmount(index)); //Foreign amount
     Console.WriteLine("MCPErrorStatusCode = " + receipt.GetMCPErrorStatusCode(index));
     Console.WriteLine("MCPErrorMessage = " + receipt.GetMCPErrorMessage(index));
    } 
    Console.ReadLine();
    } 
    catch (Exception e)
    { 
     Console.WriteLine(e);
    }
   }
  }
 }
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken } = this.props;

        return (
            <pre className="sampleCode">
{`package Canada;

import JavaAPI.*;

public class TestCanadaMCPGetRate
{ 
 public static void main(String[] args)
 { 
  String store_id = "`}{this.getValue(storeId, "storeId")}{`";
  String api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
  String processing_country_code = "CA";

  MCPGetRate getRate = new MCPGetRate();

  getRate.setMCPVersion("1.0"); //MCP Version number. Should always be 1.0
  getRate.setRateTxnType("P"); //P or R are valid values (Purchase or Refund)

  MCPRate rate = new MCPRate();

  rate.addCardholderAmount("500", "840"); //penny value amount 1.25 = 125. Foreign amount and SO-4217
  country currency number
  //rate.addMerchantSettlementAmount("200", "826"); //penny value amount 1.25 = 125. Domestic(CAD)
  amount and SO-4217 country currency number
  //rate.addMerchantSettlementAmount("300", "036"); //penny value amount 1.25 = 125. Domestic(CAD)
  amount and SO-4217 country currency number
  getRate.setMCPRateInfo(rate);

  HttpsPostRequest mpgReq = new HttpsPostRequest();

  mpgReq.setProcCountryCode(processing_country_code);
  mpgReq.setTestMode(true); //false or comment out this line for production transactions
  mpgReq.setStoreId(store_id);
  mpgReq.setApiToken(api_token);
  mpgReq.setTransaction(getRate);
  mpgReq.send();

  try
  { 
   Receipt receipt = mpgReq.getReceipt();

   System.out.println("RateTxnType = " + receipt.getRateTxnType());
   System.out.println("MCPRateToken = " + receipt.getMCPRateToken());
   System.out.println("RateInqStartTime = " + receipt.getRateInqStartTime()); //The time (unix UTC) of when the rate is requested
   System.out.println("RateInqEndTime = " + receipt.getRateInqEndTime()); //The time (unix UTC) of when the rate is returned
   System.out.println("RateValidityStartTime = " + receipt.getRateValidityStartTime()); //The time (unix UTC) of when the rate is valid from
   System.out.println("RateValidityEndTime = " + receipt.getRateValidityEndTime()); //The time (unix UTC) of when the rate is valid until
   System.out.println("RateValidityPeriod = " + receipt.getRateValidityPeriod()); //The time in minute this rate is valid for
   System.out.println("ResponseCode = " + receipt.getResponseCode());
   System.out.println("Message = " + receipt.getMessage());
   System.out.println("Complete = " + receipt.getComplete());
   System.out.println("TransDate = " + receipt.getTransDate());
   System.out.println("TransTime = " + receipt.getTransTime());
   System.out.println("TimedOut = " + receipt.getTimedOut()); 
   
   //RateData
   for (int index = 0; index < receipt.getRatesCount(); index++)
   { 
    System.out.println("MCPRate = " + receipt.getMCPRate(index));
    System.out.println("MerchantSettlementCurrency = " + receipt.getMerchantSettlementCurrency(index));
    System.out.println("MerchantSettlementAmount = " + receipt.getMerchantSettlementAmount(index));
    //Domestic(CAD) amount
    System.out.println("CardholderCurrencyCode = " + receipt.getCardholderCurrencyCode(index));
    System.out.println("CardholderAmount = " + receipt.getCardholderAmount(index)); //Foreign amount
    System.out.println("MCPErrorStatusCode = " + receipt.getMCPErrorStatusCode(index));
    System.out.println("MCPErrorMessage = " + receipt.getMCPErrorMessage(index));
   }
  } 
  catch (Exception e)
  { 
   e.printStackTrace();
  }
 }
}
`}
            </pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken } = this.props;

        return (
            <pre className="sampleCode">
{`<?php
##
## Example php -q TestPurchase.php store1
##
require "../../mpgClasses.php";
/**************************** Request Variables *******************************/
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
$type = 'mcp_get_rate';
$mcp_version = '1.0';
$rate_txn_type = 'P';
/*********************** Transactional Associative Array **********************/
$txnArray=array('type'=>$type, 'mcp_version'=>$mcp_version, 'rate_txn_type'=>$rate_txn_type);
/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($txnArray);
/******************* Credential on File **********************************/
$mcpRate = new MCPRate();
$mcpRate->setCardholderAmount('100', '840');
$mcpRate->setMerchantSettlementAmount('200', '826');
$mpgTxn->setMCPRateInfo($mcpRate);
/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions
/***************************** HTTPS Post Object *****************************/
/* Status Check Example
$mpgHttpPost =new mpgHttpsPostStatus($store_id,$api_token,$status_check,$mpgRequest);
*/
$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);
/******************************* Response ************************************/
$mpgResponse=$mpgHttpPost->getMpgResponse();

print("\\nRateTxnType = " . $mpgResponse->getRateTxnType());
print("\\nMCPRateToken = " . $mpgResponse->getMCPRateToken());
print("\\nRateInqStartTime = " . $mpgResponse->getRateInqStartTime()); //The time (unix UTC) of when the rate is requested
print("\\nRateInqEndTime = " . $mpgResponse->getRateInqEndTime()); //The time (unix UTC) of when the rate is returned
print("\\nRateValidityStartTime = " . $mpgResponse->getRateValidityStartTime()); //The time (unix UTC) of when the rate is valid from
print("\\nRateValidityEndTime = " . $mpgResponse->getRateValidityEndTime()); //The time (unix UTC) of when the rate is valid until
print("\\nRateValidityPeriod = " . $mpgResponse->getRateValidityPeriod()); //The time in minutes this rate is valid for
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());

//RateData
for ($index = 0; $index < $mpgResponse->getRatesCount(); $index++)
{ 
 print("\\nMCPRate = " . $mpgResponse->getMCPRate($index));
 print("\\nMerchantSettlementCurrency = " . $mpgResponse->getMerchantSettlementCurrency($index));
 print("\\nMerchantSettlementAmount = " . $mpgResponse->getMerchantSettlementAmount($index));
 //Domestic(CAD) amount
 print("\\nCardholderCurrencyCode = " . $mpgResponse->getCardholderCurrencyCode($index));
 print("\\nCardholderAmount = " . $mpgResponse->getCardholderAmount($index)); //Foreign amount
 print("\\nMCPErrorStatusCode = " . $mpgResponse->getMCPErrorStatusCode($index));
 print("\\nMCPErrorMessage = " . $mpgResponse->getMCPErrorMessage($index));
} 
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, onEditId } = state.mcp.main.config;
    const { selection } = state.common.progLangList;
    return { storeId, apiToken, progLangId: selection, onEditId };
  }
  
  export default connect(mapStateToProps, {})(GetRateSample)